@use "sass:color";
@use "sass:string";
@use "utils" as *;

// kebab-case-name, value
$colors: (
    // Primary
    ("black", #0c0c0c),
    ("off-white", #f0edec),
    ("red", #901215),
    ("eggplant", #261331),
    ("maroon", #44181b),
    ("pecan", #c59f89),
    ("beige", #e2cfc6),
    // System
    ("gray-900", #332f2b),
    ("gray-700", #54514e),
    ("gray-500", #757270),
    ("gray-300", #c8c5c1),
    ("gray-100", #e3e2e0),
    ("white", #fff),
    // Overlays
    ("overlay-off-white-20", rgb(from var(--off-white) r g b / 20%)),
    ("overlay-off-white-56", rgb(from var(--off-white) r g b / 56%)),
    ("overlay-off-white-80", rgb(from var(--off-white) r g b / 80%)),
    ("overlay-black-20", rgb(from var(--black) r g b / 20%)),
    ("overlay-black-56", rgb(from var(--black) r g b / 56%)),
    ("overlay-black-80", rgb(from var(--black) r g b / 80%)),
    (
        "overlay-black-gradient",
        linear-gradient(
            180deg,
            rgb(from var(--black) r g b / 0%) 0%,
            rgb(from var(--black) r g b / 80%) 100%
        )
    ),
    (
        "overlay-white-gradient",
        linear-gradient(
            180deg,
            rgb(from var(--white) r g b / 0%) 0%,
            rgb(from var(--white) r g b / 80%) 100%
        )
    ),
    (
        "overlay-black-gradient-horizontal",
        linear-gradient(
            90deg,
            rgb(from var(--black) r g b / 0%) 0%,
            rgb(from var(--black) r g b / 80%) 100%
        )
    ),
    // Gradients
    (
            "gradient-dark-1",
            linear-gradient(180deg, var(--gray-900) 0%, var(--black) 100%)
        ),
    (
        "gradient-dark-2",
        linear-gradient(180deg, var(--eggplant) 0%, var(--black) 100%)
    ),
    (
        "gradient-dark-3",
        linear-gradient(180deg, var(--maroon) 0%, var(--black) 100%)
    ),
    (
        "gradient-light-1",
        (
            linear-gradient(
                180deg,
                rgb(from var(--gray-300) r g b / 0%) 50%,
                rgb(from var(--gray-900) r g b / 50%) 100%
            ),
            var(--off-white)
        )
    ),
    (
        "gradient-light-2",
        (
            linear-gradient(
                180deg,
                rgb(from var(--beige) r g b / 0%) 50%,
                rgb(from var(--pecan) r g b / 60%) 100%
            ),
            var(--off-white)
        )
    ),
    (
        "gradient-light-3",
        (
            linear-gradient(
                0deg,
                rgb(from var(--maroon) r g b / 0%) 50%,
                rgb(from var(--maroon) r g b / 50%) 100%
            ),
            var(--off-white)
        )
    )
);

// Export is for JS purposes. Sometimes SVG fills too!
:export {
    @each $name, $value in $colors {
        #{kebab-to-camel($name)}: #{$value};
    }
}

// This creates the custom properties that we'll use a ton
:root[data-design-version="v2026"] {
    @each $name, $value in $colors {
        --#{string.unquote($name)}: #{$value};
    }
}
